import { inject, isDevMode } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserDataService } from './userData.service';

export const SiteAdminGuard: CanActivateFn = () => {
  if (isDevMode()) return true;
  const userDataService = inject(UserDataService);
  const router          = inject(Router);
  return userDataService.siteAdmin() ? true : router.createUrlTree(['/no-access']);
};
